import React, { useContext, useEffect, useState } from 'react'
import { useMutation } from 'react-query'
import { ContextType, verificationContext } from '../context/VerificationContext'
import { Typography, Divider, List, ListItem, ListItemText, IconButton } from '@mui/material'
import EditNoteIcon from '@mui/icons-material/EditNote';
import ErrorIcon from '@mui/icons-material/Error';
import usePopup from '../../../hooks/usePopup'
import Problems from '../../../EMR/components/Problems/Problems'
import { getproblems } from '../../../EMR/services'
import { getProblemType } from '../../../EMR/components/Problems/type'


function ProblemsTable() {
  const {CustomModal} = usePopup()
    const {searchData}=useContext(verificationContext) as ContextType
    const [open,setOpen] = useState<boolean>(false)
    const [tableData,setTableData]=useState<getProblemType[]|[]>([])
    const {mutate:getProblemsList}=useMutation(getproblems,{onSuccess:(data)=>{setTableData(data.response) }})
    useEffect(()=>{
      if(searchData?.encounter?.encounterId){
        getProblemsList(`${searchData?.encounter?.encounterId}`)
      }
    },[searchData?.encounter?.encounterId])

    const closepopUp=()=>{
          getProblemsList(`${searchData?.encounter?.encounterId}`)
          setOpen(false)
 }
  return (
    <>
      <CustomModal title='Problems' open={open} setOpen={setOpen} handleClose={()=>{closepopUp()}}>
       <div className='w-[50vw] '>
          <Problems/>
       </div>
    </CustomModal>
     <div className='flex  justify-between me-5'>
       <Typography className="!ml-2">
          <strong>Problems</strong>
      </Typography>
      <IconButton onClick={()=>{setOpen(true)}} edge="end" aria-label="delete">
               <EditNoteIcon color='primary' />
       </IconButton>
     </div>
    <Divider />

      <List>
          {
           tableData?.length>0 ?(  tableData?.map((item:getProblemType)=>{
              return(
               <>
                  <ListItem alignItems="flex-start">
                  <ListItemText
                  primary={`${item?.icdSnomedDto?.snomedDescription}-${item.icdDto?.icdCode}`}
                  secondary={
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="body2"
                        sx={{ color: 'text.primary', display: 'inline' }}
                      >
                      
                      </Typography>
                 
                    </React.Fragment>
                  }
                />
                  </ListItem>
                <Divider />
               </>
              )
             })):  
           <div className="col-span-12 flex justify-center items-center flex-col gap-2">
             <ErrorIcon color="info" sx={{fontSize:"2rem"}}/>
             No Problems found
           </div>
           }
     
      </List>


       </>
  )
}

export default ProblemsTable
